var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadedPage)?_c('div',{staticClass:"receipt-details"},[(_vm.progress)?_c('ReceiptProgress',{attrs:{"admin":_vm.admin,"titles":true,"receipt":_vm.receipt}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }